const _records = Symbol();
const _pageNumber = Symbol();
const _pageSize = Symbol();
const _total = Symbol();

export class SearchResult {
	constructor(records, pageNumber, pageSize, total) {
		this.records = records;
		this.pageNumber = pageNumber;
		this.pageSize = pageSize;
		this.total = total;
	}
	get records() {
		return this[_records];
	}
	set records(v) {
		if(!Array.isArray(v))
			throw new TypeError('records must be an array.');
		this[_records] = v;
	}
	get pageNumber() {
		return this[_pageNumber];
	}
	set pageNumber(v) {
		if(!Number.isInteger(v))
			throw new TypeError('pageNumber must be an integer.');
		this[_pageNumber] = v;
	}
	get pageSize() {
		return this[_pageSize];
	}
	set pageSize(v) {
		if(!Number.isInteger(v))
			throw new TypeError('pageSize must be an integer.');
		this[_pageSize] = v;
	}
	get total() {
		return this[_total];
	}
	set total(v) {
		if(!Number.isInteger(v))
			throw new TypeError('total must be an integer.');
		this[_total] = v;
	}
	toJSON() {
		return {
			records: this.records,
			pageNumber: this.pageNumber,
			pageSize: this.pageSize,
			total: this.total
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			obj.records,
			obj.pageNumber,
			obj.pageSize,
			obj.total
		);
	}
}